import { ReferencedEntry } from 'contentful';
import React from 'react';
import { BrandingBanner } from 'src/api/contentful/contentTypes.shop';
import { getField } from 'src/utils/EntryUtil';
import { isTypeByKey } from 'src/utils/Object';
import { BankPersonalizationInfo } from '../../BankPersonalization/UseBankPersonalization';
import { ContentfulImage } from '../../Contentful/ContentfulImage';
import { Image } from '../../Image/Image';

export const BannerImage: React.FC<React.AllHTMLAttributes<HTMLDivElement> & {
  bannerInfo?: ReferencedEntry<BrandingBanner> | BankPersonalizationInfo;
  children?: never;
}> = ({ bannerInfo, ...props }) => {
  const hasValidInfo = isTypeByKey(bannerInfo, 'sys') || (bannerInfo && bannerInfo.partnerLogo && bannerInfo.partnerName);

  if (!bannerInfo || !hasValidInfo) return null;

  return (
    <div {...props}>
      {
        isTypeByKey(bannerInfo, 'sys') ?
          <ContentfulImage data-test="partner-logo" asset={getField(bannerInfo, 'iconImage')} /> :
          bannerInfo.asset ?
            <ContentfulImage asset={bannerInfo.asset} /> :
            <Image src={bannerInfo.partnerLogo} alt={bannerInfo.partnerName} />
      }
    </div>
  );
};
